import React from "react"
import { connect } from "react-redux"
import NotificationAlert from "react-notification-alert"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { addAccountDetails } from "actions/organization/usersActions"

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap"

class AccountDetails extends React.Component {
  customersCollection = "customers"

  componentDidMount() {
    if (this.props.merchant) {
      const { routingNumber, accountNumber } = this.props.merchant[0] || {}
      const newState = this.state.customStyles
      newState.routingNumber = routingNumber
      newState.accountNumber = accountNumber
      this.setState({
        customStyles: newState,
      })
    }
  }

  componentDidUpdate(prevProps) {
    console.log(!prevProps.merchant, this.props.merchant)
    if (!prevProps.merchant && this.props.merchant) {
      const { routingNumber, accountNumber } = this.props.merchant[0] || {}
      const newState = this.state.customStyles
      newState.routingNumber = routingNumber
      newState.accountNumber = accountNumber
      this.setState({
        customStyles: newState,
      })
    }
  }

  state = {
    customStyles: {
      routingNumber: "",
      routingNumberState: null,
      accountNumber: "",
      accountNumberState: null,
    },
    disableAddAccountInfo: false,
  }

  validateCustomStylesForm = () => {
    let newState = this.state.customStyles
    if (newState.routingNumber === "") {
      newState.routingNumberState = "invalid"
    } else if (newState.accountNumber === "") {
      newState.accountNumberState = "invalid"
    }
    this.setState({
      customStyles: newState,
    })
  }

  customStylesForm = (e, stateName) => {
    console.log(e.target.value, stateName)
    let newState = this.state.customStyles
    newState[stateName] = e.target.value
    newState[stateName + "State"] = "invalid"
    if (stateName === "routingNumber") {
      newState[stateName] = e.target.value.slice(0, 10)
      if (e.target.value.trim().slice(0, 10).length === 10) {
        newState[stateName + "State"] = "valid"
      }
    } else if (stateName === "accountNumber") {
      newState[stateName] = e.target.value.slice(0, 10)
      if (e.target.value.trim().slice(0, 10).length === 10) {
        newState[stateName + "State"] = "valid"
      }
    }
    this.setState({
      customStyles: newState,
    })
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  render() {
    return (
      <>
        <SimpleHeader name="Add Account Info" parentName="Users" />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <h3 className="mb-0">Add Account Info</h3>
                  </CardHeader>
                  <CardBody>
                    <Form className="needs-validation" noValidate>
                      <div className="form-row">
                        <Col className="mb-3" md="6">
                          <label
                            className="form-control-label"
                            htmlFor="validationCustom02"
                          >
                            Account Number
                          </label>
                          <Input
                            // defaultValue=""
                            value={this.state.customStyles.accountNumber}
                            id="validationCustom02"
                            placeholder="1234567890"
                            type="text"
                            valid={
                              this.state.customStyles.accountNumberState ===
                              "valid"
                            }
                            invalid={
                              this.state.customStyles.accountNumberState ===
                              "invalid"
                            }
                            onChange={(e) =>
                              this.customStylesForm(e, "accountNumber")
                            }
                            autoComplete="off"
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Account Number Should Be 10 Characters Long!
                          </div>
                        </Col>
                        <Col className="mb-3" md="6">
                          <label
                            className="form-control-label"
                            htmlFor="validationCustom01"
                          >
                            Routing Number
                          </label>
                          <Input
                            // defaultValue=""
                            value={this.state.customStyles.routingNumber}
                            id="validationCustom01"
                            placeholder="1234567890"
                            type="text"
                            valid={
                              this.state.customStyles.routingNumberState ===
                              "valid"
                            }
                            invalid={
                              this.state.customStyles.routingNumberState ===
                              "invalid"
                            }
                            onChange={(e) =>
                              this.customStylesForm(e, "routingNumber")
                            }
                            autoComplete="off"
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Routing Number Should Be 10 Characters Long!
                          </div>
                        </Col>
                      </div>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                          const { customStyles } = this.state
                          const { routingNumber, accountNumber } = customStyles
                          if (
                            routingNumber &&
                            accountNumber &&
                            this.props.uid
                          ) {
                            this.setState({ disableAddAccountInfo: true })
                            this.props
                              .addAccountDetails(
                                routingNumber,
                                accountNumber,
                                this.props.uid
                              )
                              .then((areDetailsAdded) => {
                                // const defVal = 'default';
                                let message = ""
                                if (areDetailsAdded) {
                                  message = "Account Details Added!"
                                  return this.notify(
                                    "success",
                                    message,
                                    "Success"
                                  )
                                } else {
                                  message = "Account Details Not Added!"
                                  return this.notify(
                                    "danger",
                                    message,
                                    "Warning"
                                  )
                                }
                              })
                          } else {
                            return this.notify(
                              "danger",
                              "Please Enter All The Details.",
                              "Warning"
                            )
                          }
                        }}
                        disabled={this.state.disableAddAccountInfo}
                      >
                        Add Account Info
                      </Button>
                      {this.state.disableAddAccountInfo ? (
                        <Button
                          color="primary"
                          type="button"
                          onClick={() => {
                            const customStyles = this.state.customStyles
                            customStyles.name = ""
                            customStyles.nameState = null
                            customStyles.email = ""
                            customStyles.emailState = null
                            customStyles.status = ""
                            customStyles.statusState = null

                            return this.setState({
                              disableAddAccountInfo: false,
                              customStyles,
                            })
                          }}
                        >
                          Reset
                        </Button>
                      ) : null}
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    uid: state.firebase.auth.uid,
    merchant: state.firestore.ordered.merchant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addAccountDetails: (routingNumber, accountNumber, uid) =>
      dispatch(addAccountDetails(routingNumber, accountNumber, uid)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails)
